import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConsentsTitle = () => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="titleMedium"
      sx={{ fontSize: '16px', fontWeight: 400 }}
    >
      {t('enrollmentAgreementWelcome.title')}
    </Typography>
  );
};

export default ConsentsTitle;
